export default "__VITE_ASSET__CKYEPBFI__"